import Icon from '../../generic/Icon/Icon';
import Text from '../../generic/Text';
import type { IconClassName } from '../../generic/Icon';
import type { AuthContextState } from '../context/AuthContext';

export type SubtitleAction = {
  icon: IconClassName;
  label: string;
  onClick: () => void;
};

type FormHeadingProps = Partial<Pick<AuthContextState, 'orgTitle'>> & {
  heading: string;
  subtitleAction?: SubtitleAction;
};

/**
 * Heading component for the AuthForm.
 */
const AuthFormHeading = ({ heading, orgTitle, subtitleAction }: FormHeadingProps) => {
  return (
    <>
      <Text.H1>
        {heading}
      </Text.H1>
      {orgTitle ? (
        <span className="fossa-auth__form__heading__org-title">
          <span className="fossa-auth__form__heading__org-title__text" title={orgTitle}>
            {orgTitle}
          </span>
          {subtitleAction ? (
            <button
              type="button"
              className="fossa-auth__form__heading__org-title__action"
              onClick={subtitleAction.onClick}
              title={subtitleAction.label}
              aria-label={subtitleAction.label}
            >
              <Icon icon={subtitleAction.icon} />
            </button>
          ) : null}
        </span>
      ) : null}
    </>
  );
};

export default AuthFormHeading;
